import { Component, OnDestroy, OnInit } from '@angular/core';
import { map, Subscription } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
@Component({
  selector: 'mdk-login-button',
  templateUrl: './login-button.component.html'
})
export class LoginButtonComponent implements OnDestroy {
  private subscriptions = new Subscription();

  constructor(private authService: AuthenticationService) { }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onLogIn(): void {
    this.authService.login();
  }
}
